import { render, staticRenderFns } from "./UserHelp.vue?vue&type=template&id=fcfe2e90&scoped=true&"
import script from "./UserHelp.vue?vue&type=script&lang=js&"
export * from "./UserHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcfe2e90",
  null
  
)

export default component.exports